import type { FlightCardData } from '@massilia/queries'

import { FlightCard } from './flight-card'
import { FlightCardSkeleton } from './flight-card-skeleton'

interface FlightListProps {
  isLoading?: boolean
  offers: FlightCardData[]
  onSelectFlight?: (flight: FlightCardData) => void
  transactionKey: string
}

export function FlightList({ isLoading, offers, onSelectFlight, transactionKey }: FlightListProps) {
  if (isLoading) {
    return (
      <div className="space-y-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <FlightCardSkeleton key={i} />
        ))}
      </div>
    )
  }

  if (offers.length === 0) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-12 text-center">
        <div className="text-gray-600">
          <div className="mb-2 text-lg font-semibold">Aucun vol trouvé</div>
          <div className="text-sm">
            Essayez de modifier vos critères de recherche pour trouver des vols disponibles.
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {offers.map((offer) => (
        <FlightCard
          flight={offer}
          key={offer.offerId}
          onSelect={onSelectFlight}
          transactionKey={transactionKey}
        />
      ))}
    </div>
  )
}
